var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenuLike = function SvgIconMenuLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.175 6.741.525.515.525-.515.543-.532a5.108 5.108 0 0 1 3.6-1.459c1.365 0 2.64.519 3.6 1.46l.526-.537-.525.536a4.89 4.89 0 0 1 0 7.011l-8.151 7.986h-.001a.172.172 0 0 1-.145.04v.001l-.01-.002a.146.146 0 0 1-.079-.038v-.001L4.43 13.22a4.89 4.89 0 0 1 0-7.01l-.525-.537.525.536a5.107 5.107 0 0 1 3.6-1.459c1.365 0 2.641.519 3.601 1.46l.543.531Z",
    fill: "#fff",
    stroke: "#343637",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.113 6.852a.676.676 0 0 1-.529.81c-.383.077-.71.3-.897.612-.202.348-.244.775-.105 1.25a.677.677 0 0 1-.47.845.698.698 0 0 1-.855-.476c-.245-.838-.167-1.662.244-2.333a2.723 2.723 0 0 1 1.79-1.242.699.699 0 0 1 .822.534Z",
    fill: "url(#icon_menu_like_svg__a)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_menu_like_svg__a",
    x1: 6.253,
    y1: 7.076,
    x2: 6.604,
    y2: 11.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })))));
};
export default SvgIconMenuLike;